import type { ObjectMetadata } from '@olytic/foundation';

import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asLabel, column, createdByField, field, lastModifiedByField, type Row, related, text } from './kit';

const def = OBJECT_DEFS['product-groups'];

/** How products are grouped within a family. Rationale: product-groups.md. */
export const productGroups: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Product group',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('name', 'Name'),
    field('code', 'Code'),
    field('family', 'Family', { format: asLabel }),
    field('revenue_stream', 'Revenue Stream', {
      format: asLabel,
      help: 'Where its revenue rolls up for planning. A consulting group rolls up to Workstream or Consulting; studio, software and AI agents groups to their own.',
    }),
    field('description', 'Description', { wide: true }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['name', 'code', 'family', 'revenue_stream'] },
    { key: 'description', label: 'Description', fields: ['description'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_by_name', 'last_modified_by_name'] },
  ],
  related: [
    related('products', 'Products', 'products', [
      column('name', 'Product', { primary: true }),
      column('status', 'Status', { format: asLabel }),
    ]),
  ],
  titleOf: (row) => text(row.name),
  searchKeys: ['code', 'name'],
};
